export default function tier4Slideshow() {
  const widgetName = 'tier4Slideshow';
  const widgetOpts = tier4SlideshowOpts;
  const $widget = $(`#${widgetName}`);

  return new Promise((resolve) => {
    saffire.utils.getWidgetData(widgetOpts).then(function (response) {
      if (response.Slides.length > 0) {
        $widget.html(swiperContainers);
        initSwiper(response.Slides, widgetName);
        resolve(true);
      } else {
        $(`#${widgetName}`).remove();
        $('body').addClass('tier4Slideshow-no-data');
        resolve(false);
      }
    });
  });
}

// -----------------------------
// Swiper Initialization
function initSwiper(widgetData, widgetName) {
  if (widgetData.length <= 1) {
    $(`#${widgetName} .content-wrap-inner`).addClass('single-slide');
    $(`#${widgetName} .pagination-container`).addClass('single-slide');
  }

  const swiperWidgetImagesWrapper = $(`#${widgetName} .swiper-container-images .swiper-wrapper`);

  widgetData.forEach((slide) => {
    swiperWidgetImagesWrapper.append(buildSlideTemplateImages(slide));
  });

  const swiperImages = new Swiper(`#${widgetName} .swiper-container-images`, {
    speed: 600,
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
    },
    loop: widgetData.length > 1,
    watchOverflow: true,
    spaceBetween: 0,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 1,
    },
    a11y: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    observer: true,
    observeParents: true,
    pagination: {
      el: $(`#${widgetName}`).find('.swiper-pagination'),
      clickable: true,
    },
    navigation: {
      nextEl: `#${widgetName} .swiper-button-next`,
      prevEl: `#${widgetName} .swiper-button-prev`,
    },
    on: {
      init: function () {
        updateImageA11y(this);
      },
      slideChangeTransitionEnd: function () {
        updateImageA11y(this);
      },
    },
  });

  // -----------------------------
  // Observer
  const sliderToObserve = document.querySelector(`#${widgetName} .swiper-container-images`);

  if (sliderToObserve) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.isIntersecting ? swiperImages.autoplay.start() : swiperImages.autoplay.stop();
        });
      },
      { threshold: 0.3 },
    );

    observer.observe(sliderToObserve);
  }

  return { swiperImages };
}

// -----------------------------
// Swiper Containers
const swiperContainers = `
    <div class="swiper-container swiper-container-images">
      <div class="swiper-wrapper"></div>
    </div>

    <div class="slideshow-controls">
      <div class="swiper-button-prev"></div>
      <div class="swiper-pagination"></div>
      <div class="swiper-button-next"></div>
    </div>
    </div>

  `;

// -----------------------------
// Slide Template - Images
function buildSlideTemplateImages(slide) {
  const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container swiper-lazy" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">
          <div class="swiper-lazy-preloader"></div>
        </div>
      </div>
    `;

  return template;
}

// -----------------------------
// updating images a11y
function updateImageA11y(swiper) {
  const $slides = $(swiper.slides);

  $slides.each(function (_, slide) {
    const $slide = $(slide);
    const isActive = $slide.hasClass('swiper-slide-active');

    $slide.attr('aria-hidden', isActive ? 'false' : 'true');
  });
}
